
(function () {

  function shouldShowNewArrival(card) {
    const reviewWrapper = card.querySelector('.scm-reviews-rate');
    if (!reviewWrapper) return true;

    const star = reviewWrapper.querySelector('.lai-content-star');
    if (!star) return true;

    const style = window.getComputedStyle(star);

    // core condition
    return style.display === 'none';
  }

  function addBadge(card) {
    if (card.querySelector('.new-arrival-badge')) return;

    const badge = document.createElement('div');
    badge.className = 'new-arrival-badge';
    badge.textContent = 'New Arrival';

    card.appendChild(badge);
  }

  function removeBadge(card) {
    const badge = card.querySelector('.new-arrival-badge');
    if (badge) badge.remove();
  }

  function processCard(card) {
    if (shouldShowNewArrival(card)) {
      addBadge(card);
    } else {
      removeBadge(card);
    }
  }

  function scanAll() {
    document.querySelectorAll('.product-item').forEach(processCard);
  }

  // Initial + delayed rechecks (LAI async fix)
  document.addEventListener('DOMContentLoaded', function () {
    scanAll();
    setTimeout(scanAll, 1500);
    setTimeout(scanAll, 3000);
  });

  // Ajax / infinite scroll / late DOM changes
  const observer = new MutationObserver(scanAll);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();
